import {
  // FiUser,
  FiGift,
  FiAlertCircle,
  FiHelpCircle,
  FiTruck,
  FiPhoneCall,
  FiCreditCard,
  FiMail,
  FiMapPin,
  FiCodesandbox,
  FiDollarSign,
  FiBell,
} from "react-icons/fi";
import {
  HiOutlineDocumentText,
  HiOutlinePhoneIncoming,
  HiOutlineShieldCheck,
  HiOutlineUserGroup,
  HiTruck,
  HiOutlineSparkles,
  HiOutlineReceiptRefund,
} from "react-icons/hi";
import {
  IoBagCheckOutline,
  IoGridOutline,
  IoListOutline,
  IoSettingsOutline,
} from "react-icons/io5";
import { MdFiberNew, MdCheckCircleOutline } from "react-icons/md";

import { RiDashboardLine } from "react-icons/ri";
import { TbHourglassLow } from "react-icons/tb";



import { FaPager, FaForumbee } from "react-icons/fa";

const pages = [
  // {
  //   title: 'User',
  //   href: '/user/dashboard',
  //   icon: FiUser,
  // },
  //{
   // title: "Int'l Competition(Reg ended)",
  //  href: "https://rebrand.ly/enkw6va",
 //   icon: FiCodesandbox,
//  },
  {
    title: "Offer",
    href: "/offer",
    icon: FiGift,
  },
  {
    title: "Latest Releases",
    href: "/new",
    icon: HiOutlineSparkles,
  },
  {
    title: "In-stock Products",
    href: "/available",
    icon: MdCheckCircleOutline,
  },
  {
    title: "Upcoming Shipments",
    href: "https://docs.google.com/spreadsheets/d/1Nb_z1lia3AMSMffUsJ9VJXBG-pyDNRWQVVCXUsbOhKM",
    icon: TbHourglassLow,
  },
  {
    title: "FAQ",
    href: "/faq",
    icon: FiHelpCircle,
  },
  {
    title: "About Us",
    href: "/about-us",
    icon: HiOutlineUserGroup,
  },
  {
    title: "Contact Us",
    href: "/contact-us",
    icon: HiOutlinePhoneIncoming,
  },
  {
    title: "Sponsorship",
    href: "/sponsorship/",
    icon: FiDollarSign,
  },
  {
    title: "Privacy Policy",
    href: "/privacy-policy",
    icon: HiOutlineShieldCheck,
  },
  {
    title: "Terms & Conditions",
    href: "/terms-and-conditions",
    icon: HiOutlineDocumentText,
  },
  {
    title: "Refund Policy",
    href: "/refund-policy",
    icon: HiOutlineReceiptRefund,
  },
  {
    title: "Shipping and Returns",
    href: "/shipping-and-returns",
    icon: HiTruck,
  },
  {
    title: "Blog",
    href: "/blog",
    icon: FaPager,
  },
];

const user = [

  {
    title: "Dashboard",
    href: "/user/dashboard",
    icon: RiDashboardLine,
  }, 
  {
    title: "My Orders",
    href: "/user/my-orders",
    icon: FiCodesandbox,
  },   {
    title: "Settings",
    href: "#notification-settings",
    icon: FiBell,
  },

];

const userSidebar = [
  {
    title: "Dashboard",
    href: "/user/dashboard",
    icon: IoGridOutline,
  },
  {
    title: "My Orders",
    href: "/user/my-orders",
    icon: IoListOutline,
  },
  {
    title: "Update Profile",
    href: "/user/update-profile",
    icon: IoSettingsOutline,
  },
  {
    title: "Change Password",
    href: "/user/change-password",
    icon: HiOutlineDocumentText,
  },
];

const sliderData = [
  
  {
    id: 2,
    title: "",
    info: "",
    url: "/search?query=lube",
    image: "/slider/slider-1.jpg",
  },
  {
    id: 3,
    title: "",
    info: "",
    url: "/search?query=designer",
    image: "/slider/slider-2.jpg",
  },
  {
    id: 4,
    title: "",
    info: "",
    url: "https://blog.cubenationshop.com/kon-kiub-kinb-ken-which-cube-to-buy-why",
    image: "/slider/slider-3.jpg",
  },
];

const ctaCardData = [
  {
    id: 1,
    title: "For Starters",
    subTitle: " ",
    image: "/cta/cta-bg-1.jpg",
    url: "/relatedProduct/starter",
  },
  {
    id: 2,
    title: "For Everyone",
    subTitle: " ",
    image: "/cta/cta-bg-2.jpg",
    url: "/relatedProduct/everyone",
  },
  {
    id: 3,
    title: "For Professionals",
    subTitle: " ",
    image: "/cta/cta-bg-3.jpg",
    url: "/relatedProduct/pro",
  },
];

const featurePromo = [
  {
    id: 1,
    title: "Free Shipping",
    info: "From ৳1000.00",
    icon: FiTruck,
  },
  {
    id: 2,
    title: "Support 24/7",
    info: "At Anytime",
    icon: FiPhoneCall,
  },
  {
    id: 3,
    title: "Secure Payment",
    info: "Totally Safe",
    icon: FiCreditCard,
  },
  {
    id: 4,
    title: "Weekly Offers",
    info: "Always Available",
    icon: FiGift,
  },
];

const contactData = [
  {
    id: 1,
    title: "Email Us",
    info: "We typically reply back within 24 hours",
    icon: FiMail,
    contact: "support@cubenationshop.com",
    className: "bg-emerald-100",
    type: "mailto",
  },
  {
    id: 2,
    title: "Call Us",
    info: "Call us if you have any confusion.",
    icon: FiPhoneCall,
    contact: "+880-1972810849",
    className: "bg-yellow-100",
    type: "tel",
  },
  {
    id: 3,
    title: "Warehouse",
    info: "C-91/93, W2, Eastern Housing, Pallabi, Eastern Housing, Dhaka-1216",
    icon: FiMapPin,
    contact: "",
    className: "bg-indigo-100",
  },
];

export {
  pages,
  user,
  userSidebar,
  sliderData,
  ctaCardData,
  featurePromo,
  contactData,
};
